const Token = {
    namespaced: true,
    state: {
        user: 'localhost',
        key : 'je9M3yJra59sAqyRcKRMP7zxc89KPzczv5RU533zxAsF3Up4mi4SSnf7FeIZhv4Zte50b4hSaB7wv1lL',
    },
};
export default Token;